import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from './listings';

export function SelectedListing(this: ListingsService): Listing | undefined {
  if (!this.stateService.selectedListingId()) {
    return undefined;
  }

  return (
    this.filteredListings().find(
      (listing) => listing.id === this.stateService.selectedListingId(),
    ) ?? this.allListings().find((listing) => listing.id === this.stateService.selectedListingId())
  );
}
